// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router/all-routes'
import BootstrapVue from 'bootstrap-vue'
import vueSmoothScroll from 'vue-smooth-scroll'
import jQuery from 'jquery'
global.jQuery = jQuery
global.$ = jQuery
import VueLazyload from 'vue-lazyload'
import store from './storage.js'


Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(vueSmoothScroll)
Vue.use(VueLazyload)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js